import { render } from "./dxlookup-value-changed-datagrid.vue?vue&type=template&id=15dd8e38"
import script from "./dxlookup-value-changed-datagrid.vue?vue&type=script&lang=js"
export * from "./dxlookup-value-changed-datagrid.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__